import React from 'react';
import Header from '../../../Components/Header/Header';
import Login from '../../../Components/Login/Login.js';
import Footer from '../../../Components/Footer/Footer.js';

const Signin = () => {
    return (
        <>
            <Header/>
            <Login/>
            <Footer/>
        </>
    );
};

export default Signin;